import { Auth0SsoAuthService } from 'common/api';
import { getRefreshToken } from 'utils/auth';

type RefreshTokenResponse = {
  refresh_token: string;
  id_token: string;
};

export async function refreshAuth0SsoAccessTokenAPI(): Promise<RefreshTokenResponse> {
  return Auth0SsoAuthService.auth0SsoAuthControllerExchangeRefreshForBearerToken(
    {
      refreshToken: getRefreshToken() || '',
    }
  );
}
